import React from 'react';
import { isPlainObject } from 'lodash';
// ---- external imports ----


export default function withFramerMotionPropsRenamed(WrappedComponent) {
	return React.forwardRef((props, ref) => {
		const {
			x, y, scale = 1, ...restProps
		} = props;

		/**
		 * rename x, y & scale as those are shorthand props
		 * for framer motion which conflicts with responsivity system
		 */
		const position = {};

		if(!isPlainObject(x) && !!x) {
			position['xPos'] = x;
		}

		if(!isPlainObject(y) && !!y) {
			position['yPos'] = y;
		}

		return (
			<WrappedComponent
				{...position}
				sizeScale={scale}
				{...restProps}
				ref={ref}
			/>
		);
	});
}



